import ManageCalendarPage from "./components/calendar/ManageCalendarPage";
import { RolesDescription } from "./components/common/GeneralConfigurations";
import TenantRoute from "./components/common/TenantRoute";
import ManageCompanyListPage from "./components/company/ManageCompanyPage";
import ManageContractProposalListPage from "./components/contractproposal/ManageContractProposalListPage";
import ManageContractProposalPage from "./components/contractproposal/ManageContractProposalPage";
import { ManageCountryListPage } from "./components/country/ManageCountryListPage";
import ManageEmailListPage from "./components/emailList/ManageEmailListPage";
import { ManageEmployeeListPage } from "./components/employee/ManageEmployeeListPage";
import ManageEmployeePage from "./components/employee/ManageEmployeePage";
import ManageEmployeeAwardsListPage from "./components/employeeAwards/ManageEmployeeAwardsListPage";
import ManageEmployeeFollowUpEventDetailListPage from "./components/employeeFollowUpEvent/ManageEmployeeFollowUpEventDetailListPage";
import { ManageEmployeeFollowUpEventListPage } from "./components/employeeFollowUpEvent/ManageEmployeeFollowUpEventListPage";
import ManageFollowUpEventStatusListPage from "./components/followUpEventStatus/ManageFollowUpEventStatusListPage";
import ManageFollowUpEventStatusListPageBEE from "./components/followUpEventStatus/ManageFollowUpEventStatusListPageBEE";
import ManageFollowUpEventTypeListPage from "./components/followUpEventType/ManagefollowUpEventTypeListPage";
import { ManageEmployeeFollowUpEventMonthlyListPage } from "./components/employeeFollowUpEvent/ManageEmployeeFollowUpEventMonthlyListPage";
import ForbiddenPage from "./components/ForbiddenPage";
import ManageHome from "./components/home/ManageHome";
import ManageInquiry from "./components/inquiry/ManageInquiry";
import ManageForgotPage from "./components/login/forget/ManageForgotPage";
import ManageLoginPage from "./components/login/ManageLoginPage";
import ManageRecoverPage from "./components/login/recover/ManageRecoverPage";
import ManageMemberProfilePage from "./components/memberProfile/ManageMemberProfilePage";
import NotFoundPage from "./components/NotFoundPage";
import { ManageNotificationListPage } from "./components/notification/ManageNotificationListPage";
import ManageOfferListPage from "./components/offer/ManageOfferListPage";
import ManageOfferTypeListPage from "./components/offertype/ManageOfferTypeListPage";
import ManageProjectListPage from "./components/project/ManageProjectListPage";
import ManageProjectPage from "./components/project/ManageProjectPage";
import ManageProjectTeamMemberPage from "./components/project/ManageProjectTeamMemberPage";
import ManageTechnologyListPage from "./components/technology/ManageTechnologyPage";
import { ManageTechSpecializedListPage } from "./components/techSpecialized/ManageTechSpecializedListPage";
import ManageTemplateListPage from "./components/template/ManageTemplateListPage";
import ManageTextMessagePage from "./components/textMessage/ManageTextMessagePage";
import { ManageUserListPage } from "./components/user/ManageUserListPage";
import { ManageUserPage } from "./components/user/ManageUserPage";
import ManageUserProfilePage from "./components/userprofile/ManageUserProfilePage";
import { ManageWhatsappGroupListPage } from "./components/whatsappgroup/ManageWhatsappGroupListPage";
import { ManageWhatsappGroupPage } from "./components/whatsappgroup/ManageWhatsappGroupPage";
import ManageMessageStatisticListPage from "./components/messageStatistic/ManageMessageStatisticListPage";
import { ManageFirstMonthAssessmentPage } from "./components/firstMonthAssessment/ManageFirstMonthAssessmentPage";
import ManageCertificationTypesListPage from "./components/certificationTypes/ManageCertificationTypesListPage";
import ManageQuizBuilderPage from "./components/quizBuilder/ManageQuizBuilderPage";
import ManageQuizListPage from "./components/quizBuilder/ManageQuizListPage";
import ManageQuizAnswerPage from "./components/employeeFollowUpEvent/ManageQuizAnswerPage";
import ManageReportListPage from "./components/report/ManageReportListPage";
import ManageCriticalSituationListPage from "./components/criticalSituation/ManageCriticalSituationListPage";
import ManageCriticalSituationPage from "./components/criticalSituation/ManageCriticalSituationPage";
import ManageWelcomeSessionListPage from "./components/welcomeSession/ManageWelcomeSessionListPage";
import LoginPageForm from "./components/login2/LoginPageForm";
import MicrosoftLoginCallback from "./components/login2/MicrosoftLoginCallback";
import OktaCallBack from "./components/login2/OktaCallBack";
import { config } from "./config";

export const AppRoutes = {
  // Unauthenticated
  homeUnauthenticated: {
    key: 0,
    path: "/",
    element:
      config.enable === "false" ? <ManageLoginPage /> : <LoginPageForm />,
    //element: <ManageLoginPage />,
    //element: <LoginPageForm />,
  },
  notFoundUnauthenticated: {
    key: 1,
    path: "*",
    element:
      config.enable === "false" ? <ManageLoginPage /> : <LoginPageForm />,
    //element: <ManageLoginPage />,
  },
  login: {
    key: 2,
    path: "/login",
    //element: <LoginPageForm />,
    element:
      config.enable === "false" ? <ManageLoginPage /> : <LoginPageForm />,
    //element: <ManageLoginPage />,
  },

  microsoftCallback: {
    key: 3367,
    path: "/microsoft/login",
    element: <MicrosoftLoginCallback />,
  },
  OktaCallBack: {
    key: 3368,
    path: "/okta/login",
    element: <OktaCallBack />,
  },

  forgot: {
    key: 3,
    path: "/forgot",
    element: <ManageForgotPage />,
  },
  recover: {
    key: 4,
    path: "/recover",
    element: <ManageRecoverPage />,
  },
  activate: {
    key: 5,
    path: "/activate",
    element: <ManageRecoverPage />,
  },
  inquiry: {
    key: 6,
    path: "/inquiry",
    element: <ManageInquiry />,
  },
  // Authenticated
  home: {
    key: 7,
    path: "/",
    element: <ManageHome />,
  },
  forbidden: {
    key: 8,
    path: "/forbidden",
    element: <ForbiddenPage />,
  },
  consultantList: {
    key: 9,
    path: "/consultantlist",
    createPath: () => `/consultantlist`,
    createPathWithSearch: (
      managerName,
      contractProposalMonth,
      contractProposalYear
    ) =>
      `/consultantlist?Name="${managerName}"&month=${contractProposalMonth}&year=${contractProposalYear}`,
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}`,
    element: <ManageEmployeeListPage />,
  },
  consultant: {
    key: 11,
    path: "/consultant",
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}`,
    element: <ManageEmployeePage />,
  },
  consultantById: {
    key: 12,
    path: "/consultant/:id",
    createPath: (id) => `/consultant/${id}`,
    createPathWithSearch: (id, offerId) =>
      `/consultant/${id}}?offer=${offerId}`,
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}`,
    element: <ManageEmployeePage />,
  },
  companies: {
    key: 13,
    path: "/companies",
    roles: `${RolesDescription.Manager}`,
    element: <ManageCompanyListPage />,
  },
  technologies: {
    key: 14,
    path: "/technologies",
    roles: `${RolesDescription.Manager}`,
    element: <ManageTechnologyListPage />,
  },
  memberProfile: {
    key: 15,
    path: "/memberprofile",
    element: <ManageMemberProfilePage />,
  },
  projectList: {
    key: 16,
    path: "/projectlist",
    roles: `${RolesDescription.Manager}`,
    element: <ManageProjectListPage />,
  },
  project: {
    key: 17,
    path: "/project",
    roles: `${RolesDescription.Manager}`,
    element: <ManageProjectPage />,
  },
  projectById: {
    key: 18,
    path: "/project/:id",
    createPath: (id) => `/project/${id}`,
    createPathWithSearch: (id, projectName) =>
      `/project/${id}/projectTeamMember?projectName=${projectName}`,
    roles: `${RolesDescription.Manager}`,
    element: <ManageProjectPage />,
  },
  projectTeamMember: {
    key: 19,
    path: "/project/:id/projectTeamMember",
    createPath: (id) => `/project/${id}/projectTeamMember`,
    roles: `${RolesDescription.Manager}`,
    element: <ManageProjectTeamMemberPage />,
  },
  consultantAwards: {
    key: 20,
    path: "/consultantawards",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageEmployeeAwardsListPage />,
  },
  templateList: {
    key: 21,
    path: "/templateList",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageTemplateListPage />,
  },
  emailList: {
    key: 22,
    path: "/emaillist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageEmailListPage />,
  },
  offerList: {
    key: 23,
    path: "/offerList",
    createPathWithSearch: (offerTypeId, offerTypeMonth, offerTypeYear) =>
      `/offerlist?offerType=${offerTypeId}&month=${offerTypeMonth}&year=${offerTypeYear}`,
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageOfferListPage />,
  },
  techSpecializationList: {
    key: 24,
    path: "/techspecializationlist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageTechSpecializedListPage />,
  },
  countryList: {
    key: 25,
    path: "/countrylist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageCountryListPage />,
  },
  offerTypeList: {
    key: 26,
    path: "/offertypelist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageOfferTypeListPage />,
  },
  followUpEventTypeList: {
    key: 27,
    path: "/followupeventtypelist",
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}}`,
    element: <ManageFollowUpEventTypeListPage />,
  },
  followUpEventStatusList: {
    key: 28,
    path: "/followupeventstatuslist",
    roles: `${RolesDescription.HumanResources}`,
    element: (
      <TenantRoute
        default={<ManageFollowUpEventStatusListPage />}
        bee={<ManageFollowUpEventStatusListPageBEE />}
      />
    ),
  },
  userList: {
    key: 29,
    path: "/userlist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageUserListPage />,
  },
  user: {
    key: 30,
    path: "/user",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageUserPage />,
  },
  userById: {
    key: 31,
    path: "/user/:id",
    createPath: (id) => `/user/${id}`,
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageUserPage />,
  },
  whatsappGroupList: {
    key: 32,
    path: "/whatsappgrouplist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageWhatsappGroupListPage />,
  },
  whatsappGroup: {
    key: 33,
    path: "/whatsappgroup",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageWhatsappGroupPage />,
  },
  whatsappGroupById: {
    key: 34,
    path: "/whatsappgroup/:id",
    createPath: (id) => `/whatsappgroup/${id}`,
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageWhatsappGroupPage />,
  },
  calendar: {
    key: 35,
    path: "/calendar",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageCalendarPage />,
  },
  followUpEventList: {
    key: 36,
    path: "/followupeventlist",
    createPathWithSearch: (
      username,
      followUpEventMonth,
      followUpEventYear,
      followUpEventStatus,
      employeeName,
      eventType
    ) => {
      const params = new URLSearchParams();
      if (username) params.set("username", username);
      if (followUpEventMonth) params.set("month", followUpEventMonth);
      if (followUpEventYear) params.set("year", followUpEventYear);
      if (followUpEventStatus) params.set("status", followUpEventStatus);
      if (employeeName) params.set("consultant", employeeName);
      if (eventType) params.set("type", eventType);
      return `/followupeventlist?${params.toString()}`;
    },
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}`,
    element: <ManageEmployeeFollowUpEventListPage />,
  },
  followUpEventById: {
    key: 37,
    path: "/followupevent/:id",
    createPath: (id) => `/followupevent/${id}`,
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}`,
    element: <ManageEmployeeFollowUpEventDetailListPage />,
  },
  contractProposalList: {
    key: 38,
    path: "/contractproposallist",
    roles: `${RolesDescription.Manager}`,
    element: <ManageContractProposalListPage />,
  },
  contractProposalListByContractType: {
    key: 39,
    path: `/contractproposallist?contractTypeId=contractTypeId`,
    createPath: (contractTypeId) =>
      `/contractproposallist?contractTypeId=${contractTypeId}`,
    roles: `${RolesDescription.Manager}`,
    element: <ManageContractProposalListPage />,
  },
  contractProposal: {
    key: 40,
    path: "/contractproposal",
    roles: `${RolesDescription.Manager}`,
    element: <ManageContractProposalPage />,
  },
  contractProposalById: {
    key: 41,
    path: "/contractproposal/:id",
    createPath: (id) => `/contractproposal/${id}`,
    roles: `${RolesDescription.Manager}`,
    element: <ManageContractProposalPage />,
  },
  notifications: {
    key: 42,
    path: "/notifications",
    element: <ManageNotificationListPage />,
  },
  notFound: {
    key: 43,
    path: "*",
    element: <NotFoundPage />,
  },
  textMessage: {
    key: 44,
    path: "/sendMessage",
    createPathWithStatisticId: (stattisticId) =>
      `/sendMessage?repeat=${stattisticId}`,
    roles: `${RolesDescription.MarketingCommunication}`,
    element: <ManageTextMessagePage />,
  },
  userProfile: {
    key: 45,
    path: "/userProfile",
    element: <ManageUserProfilePage />,
  },
  followUpEventMonthlyList: {
    key: 49,
    path: "/monthlyeventlist",
    roles: `${RolesDescription.HumanResources},${RolesDescription.Manager}`,
    element: <ManageEmployeeFollowUpEventMonthlyListPage />,
  },
  messageStatisticList: {
    key: 50,
    path: "/messageStatisticList",
    roles: `${RolesDescription.MarketingCommunication}`,
    element: <ManageMessageStatisticListPage />,
  },
  firstMonthAssessment: {
    key: 51,
    path: "/firstmonthassessment",
    element: <ManageFirstMonthAssessmentPage />,
  },
  certificationTypes: {
    key: 52,
    path: "/certificationTypes",
    element: <ManageCertificationTypesListPage />,
  },
  quizBuilder: {
    key: 53,
    path: "/quiz",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageQuizBuilderPage />,
  },
  quizBuilderById: {
    key: 54,
    path: "/quiz/:id",
    createPath: (id) => `/quiz/${id}`,
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageQuizBuilderPage />,
  },
  quizList: {
    key: 55,
    path: "/quizList",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageQuizListPage />,
  },
  quizAnswer: {
    key: 56,
    path: "/quiz-answer",
    element: <ManageQuizAnswerPage />,
  },
  reportList: {
    key: 57,
    path: "/reportList",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageReportListPage />,
  },
  criticalSituationsList: {
    key: 58,
    path: "/criticalsituationslist",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageCriticalSituationListPage />,
  },
  criticalSituation: {
    key: 59,
    path: "/criticalsituation",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageCriticalSituationPage />,
  },
  criticalSituationById: {
    key: 60,
    path: "/criticalsituation/:id",
    createPath: (id) => `/criticalsituation/${id}`,
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageCriticalSituationPage />,
  },
  welcomeSessionList: {
    key: 61,
    path: "/welcomeSessionList",
    roles: `${RolesDescription.HumanResources}`,
    element: <ManageWelcomeSessionListPage />,
  },
};

export const UnauthenticatedRoutes = [
  AppRoutes.homeUnauthenticated,
  AppRoutes.notFoundUnauthenticated,
  AppRoutes.login,
  AppRoutes.microsoftCallback,
  AppRoutes.OktaCallBack,
  AppRoutes.forgot,
  AppRoutes.recover,
  AppRoutes.activate,
  AppRoutes.inquiry,
  AppRoutes.home,
  AppRoutes.firstMonthAssessment,
  AppRoutes.quizAnswer,
];

export const AuthenticatedRoutes = [
  AppRoutes.home,
  AppRoutes.forbidden,
  AppRoutes.consultantList,
  AppRoutes.consultant,
  AppRoutes.consultantById,
  // to do: when project features are picked up, uncomment these.
  // AppRoutes.companies,
  // AppRoutes.technologies,
  // AppRoutes.memberProfile,
  // AppRoutes.projectList,
  // AppRoutes.project,
  // AppRoutes.projectById,
  // AppRoutes.projectTeamMember,
  AppRoutes.consultantAwards,
  AppRoutes.templateList,
  AppRoutes.emailList,
  AppRoutes.offerList,
  AppRoutes.templateList,
  AppRoutes.techSpecializationList,
  AppRoutes.countryList,
  AppRoutes.offerTypeList,
  AppRoutes.followUpEventTypeList,
  AppRoutes.followUpEventStatusList,
  AppRoutes.userList,
  AppRoutes.user,
  AppRoutes.userById,
  AppRoutes.whatsappGroupList,
  AppRoutes.whatsappGroup,
  AppRoutes.whatsappGroupById,
  AppRoutes.calendar,
  AppRoutes.followUpEventList,
  AppRoutes.followUpEventById,
  AppRoutes.contractProposalList,
  AppRoutes.contractProposal,
  AppRoutes.contractProposalById,
  AppRoutes.notifications,
  AppRoutes.notFound,
  AppRoutes.textMessage,
  AppRoutes.userProfile,
  AppRoutes.followUpEventMonthlyList,
  AppRoutes.messageStatisticList,
  AppRoutes.certificationTypes,
  AppRoutes.quizBuilder,
  AppRoutes.quizBuilderById,
  AppRoutes.quizList,
  AppRoutes.reportList,
  AppRoutes.criticalSituationsList,
  AppRoutes.criticalSituation,
  AppRoutes.criticalSituationById,
  AppRoutes.welcomeSessionList,
];
